import React, { useState } from "react";
import api from "../../../utilis/api";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const Subscription = ({ userData, onSave }) => {
  const { token } = useSelector((state) => state.user);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // 2️⃣ Call backend API
      const res = await api.put(
        `auth/update/${userData._id}`,
        {
          isNewsletter: true,
        },
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        },
      );

      if (res.data?.meta?.success) {
        toast.success(
          res.data.meta.message || "Password updated successfully",
          {
            autoClose: 2000,
          },
        );

        onSave();
      } else {
        toast.error(res.data?.meta?.message || "Password update failed", {
          autoClose: 4000,
        });
      }
    } catch (error) {
      const message =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Something went wrong";
      toast.error(message, { autoClose: 5000 });
    }
  };

  return (
    <form className="space-y-4" onSubmit={handleSubmit}>
      <div>
        <label className="block mb-1 font-medium">Subscribe Email</label>
        <input
          type="email"
          name="email"
          value={userData.email}
          disabled
          className="w-full border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-black"
        />
      </div>

      <div className="flex justify-end gap-2 mt-4">
        <button
          type="submit"
          className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-all duration-300"
        >
          Save
        </button>
      </div>
    </form>
  );
};

export default Subscription;
